import { isDowngrading } from "@/react/helpers/planHelpers";
import { planTiers } from "@/react/helpers/planHelpers";
import { useBillingContext } from "./BillingContext";
import { BillingDetailsContainer } from "./BillingDetailsContainer";
import { IncludedFeatures } from "./IncludedFeatures";
import { NotIncludedFeatures } from "./NotIncludedFeatures";
import { PlanHeader } from "./PlanHeader";

export const PlanDetails = () => {
  const { currentPlan } = useBillingContext();

  // [TODO][BillingRedesign] Add a loading skeleton
  if (!currentPlan) return null;

  return (
    <BillingDetailsContainer>
      <div className="flex flex-col gap-4">
        <PlanHeader />
        <IncludedFeatures />
        {isDowngrading(planTiers.enterprise, currentPlan.tier) && (
          <NotIncludedFeatures />
        )}
      </div>
    </BillingDetailsContainer>
  );
};
